var _g, _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPofile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3288_12103)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 17,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3334 32V29.3333C26.3334 27.9188 25.7715 26.5623 24.7713 25.5621C23.7711 24.5619 22.4146 24 21.0001 24H13.0001C11.5856 24 10.229 24.5619 9.22884 25.5621C8.22865 26.5623 7.66675 27.9188 7.66675 29.3333V32",
    fill: "#095D7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3334 32V29.3333C26.3334 27.9188 25.7715 26.5623 24.7713 25.5621C23.7711 24.5619 22.4146 24 21.0001 24H13.0001C11.5856 24 10.229 24.5619 9.22884 25.5621C8.22865 26.5623 7.66675 27.9188 7.66675 29.3333V32",
    stroke: "#095D7E",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0001 18.6667C19.9456 18.6667 22.3334 16.2789 22.3334 13.3333C22.3334 10.3878 19.9456 8 17.0001 8C14.0546 8 11.6667 10.3878 11.6667 13.3333C11.6667 16.2789 14.0546 18.6667 17.0001 18.6667Z",
    fill: "#095D7E",
    stroke: "#095D7E",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.335,
    y: 1.335,
    width: 31.33,
    height: 31.33,
    rx: 15.665,
    stroke: "#095D7E",
    strokeWidth: 2.67
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3288_12103"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 17,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPofile);
export default __webpack_public_path__ + "static/media/pofile.9a37c94a7150b9570e860a96a48fcb15.svg";
export { ForwardRef as ReactComponent };